import { useQuery } from '@tanstack/react-query';
import React from 'react';
import { RevolvingDot } from 'react-loader-spinner';

const AllData = () => {

    const allDataURL = 'https://lantabur-house-server.vercel.app/allData';
    const { data: allData, isLoading } = useQuery({
        queryKey: ['allData'],
        queryFn: async () => {
            const response = await fetch(allDataURL);
            const data = await response.json();
            return data;
        }
    })
    if (isLoading) {
        return (
            <div>
                <div>
                    <RevolvingDot
                        height="600"
                        width="600"
                        radius="60"
                        color="#4fa94d"
                        secondaryColor=''
                        ariaLabel="revolving-dot-loading"
                        wrapperStyle={{}}
                        wrapperClass=""
                        visible={true}
                    />
                    <h3>Please Wait.</h3>
                    <h3>System is working on your command of loading data from database.</h3>
                    <h3>Loading time depends on data size.</h3>
                    <h3>Untill loading finished, please stay with us. </h3>
                </div>
            </div>
        )
    }

    return (
        <div>
            <h2>All Data</h2>
            <table>
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Month</th>
                        <th>Bill</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        allData.map((data, i) =>
                            <tr key={i}>
                                <td>{data.Name}</td>
                                <td>{data.Month}</td>
                                <td>{data.Bill}</td>
                            </tr>
                        )
                    }
                </tbody>
                <tfoot>
                    <tr>
                        <td>table Footer</td>
                        <td>table Footer</td>
                        <td>table Footer</td>
                    </tr>
                </tfoot>


            </table>
        </div>
    );
};

export default AllData;